import { useCookie } from 'nuxt/app'
import { useGuestStore } from '~/store/guest'
import { useGuestCartStore } from '~/store/guestCart'
import { useCheckoutStore } from '~/store/checkout'

export const useResetState = () => {
  const guestStore = useGuestStore()
  const guestCartStore = useGuestCartStore()
  const checkoutStore = useCheckoutStore()

  const resetState = (clearCookies = true) => {
    if (clearCookies) {
      useCookie('employer_access_token').value = null
      useCookie('employer_store_id').value = null
      useCookie('employer_campaign_id').value = null
    }

    guestStore.reset()
    guestCartStore.reset()
    checkoutStore.reset()
  }

  return { resetState }
}
